/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";
import bibyProgram from '../programs/biby.js';

import '../util/custom-bindings.js';
import '../util/knockout-pikaday.js';

var lookups;
birdata.lookup().then(l => lookups = l);

var SurveyBibySiteConditionViewModel = function(params) {
  var self = this;

  self.survey = params.parent.survey;

  // Machinery to ensure we only initialize when needed, otherwise all surveys will have to init BIBY stuff for no reason
  self.initialized = ko.observable(false);
  ko.computed(function() {
    initialize(self.survey.programData().biby);
  });

  function initialize(biby) {
    if(self.initialized.peek() || !biby) return;

    self.showNextTab = params.parent.showNextTab;

    self.site = biby.fields.site;
    self.siteCondition = biby.fields.siteCondition;

    // Options
    self.options = {
      plantTypes: lookups.biby_plant_types,
      gardenSize: lookups.biby_garden_size,
      feedTypes: lookups.biby_feed_type,
      coverage: lookups.biby_coverage,
      animalFrequency: _.filter(lookups.biby_animal_frequency, function(x) { return x.code != 'sometimes'; }),
    };

    self.isNewSite = ko.pureComputed(function() {
      return !!(self.site() && !self.site().id);
    });

    self.isExistingSite = ko.pureComputed(function() {
      return !!(self.site() && self.site().id);
    });

    self.showConditionFields = ko.pureComputed(function() {
      return self.site();
    });

    self.enableConditionFields = ko.pureComputed(function() {
      return self.showConditionFields();
    });

    self.showNextButton = ko.pureComputed(function() {
      return !!self.site();
    });

    self.siteConditionFieldsOptional = ko.pureComputed(function() {
      return biby.isBirdsInSchools();
    });

    self.addNestBox = function() {
      var nestBox = bibyProgram.nestBoxModel();
      self.siteCondition.nestBoxes.push(nestBox);
    };

    self.removeNestBox = function(nestBox) {
      self.siteCondition.nestBoxes.remove(this);
    };
    self.occupantTypeOptions = bibyProgram.nestBoxOccupantTypes;

    self.speciesList = ko.observable([]);
    birdata.speciesList().then(self.speciesList);

    self.site.subscribe(function(site) {
      if(site && site.id) {
        // load site condition
        bibyProgram.loadSiteConditionFromJSON(site.site_condition, biby.fields.siteCondition);
      } else {
        // clear site condition
        _.each(biby.fields.siteCondition, function(value, key) {
          if(ko.isObservable(value) && !ko.isComputed(value)) {
            if(value.removeAll) {
              value.removeAll();
            } else {
              value(null);
            }
          }
        });
      }
    });

    self.initialized(true);
  }
};

ko.components.register('survey-edit-biby-site-condition', {
  viewModel: SurveyBibySiteConditionViewModel,
  template: require('../../templates/survey-edit-biby-site-condition.html')
});

export default SurveyBibySiteConditionViewModel;
